import _defineProperty from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.push.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import FilterIcon from './components/FilterIcon.vue';
export default {
  components: {
    FilterIcon: FilterIcon
  },
  data: function data() {
    return {
      loading: false,
      tableData: [],
      // 薪资类型枚举
      salary_type_enum: [],
      // 收入类型枚举
      type_enum: [],
      adding: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState({
    contentViewHeight: function contentViewHeight(state) {
      return state.settings.contentViewHeight;
    }
  })), {}, {
    tableHeight: function tableHeight() {
      return this.contentViewHeight - 120;
    }
  }),
  created: function created() {
    this.fetchTableData();
    this.get_type_enum();
  },
  methods: {
    // 获取导入项列表
    fetchTableData: function fetchTableData() {
      var _this = this;
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.loading = true;
      this.$http({
        url: '/web/payroll_setting/salaryItem',
        data: _objectSpread({
          cate_id: ['8', '10']
        }, data)
      }).then(function (res) {
        // 扩展一些前端需要用的字段
        res.data.forEach(function (item) {
          // 用于保存/编辑状态切换
          item.isSave = false;
          // 扩展一个默认是否开启的状态值
          item.defaultStatus = item.status;
          // 根据后端的返回的状态字段转扩展一个boolean
          item.switchValue = item.status === '0';
          // 扩展一个默认薪资名称 用于取消还原
          item.defaultName = item.name;
        });
        _this.tableData = res.data;
        _this.adding = false;
      }).finally(function () {
        _this.loading = false;
      });
    },
    // 获取薪资、收入类型枚举
    get_type_enum: function get_type_enum() {
      var _this2 = this;
      this.$http({
        url: '/web/payroll_setting/itemInit',
        method: 'GET'
      }).then(function (res) {
        _this2.salary_type_enum = res.data.salary_type;
        _this2.type_enum = res.data.type;
      });
    },
    // 联动更新薪资、收入类型的文本值
    update_txt_by_code: function update_txt_by_code(code, row, options, prop) {
      var option = options.find(function (item) {
        return item.code === +code;
      });
      row[prop] = option.name;
    },
    // 是否启用状态发生变化时的回调函数
    update_status: function update_status(v, r) {
      r.status = v ? '0' : '1';
      if (r.id) {
        this.$http({
          url: '/web/payroll_sub_project/switchItem',
          data: {
            id: r.id,
            status: r.status
          }
        });
      }
    },
    delete_salary_item: function delete_salary_item(scope, index) {
      var _this3 = this;
      // 如果id不存在 无需调接口 直接删
      if (!scope.row.id) {
        this.adding = false;
        this.tableData.splice(index, 1);
        return;
      }
      // 调接口删除
      this.loading = true;
      this.$http({
        url: '/web/payroll_sub_project/deleteItem',
        data: {
          id: scope.row.id
        }
      }).then(function () {
        _this3.tableData.splice(index, 1);
      }).finally(function () {
        _this3.loading = false;
      });
    },
    create_or_update_salary_item: function create_or_update_salary_item(url, data) {
      var _this4 = this;
      this.loading = true;
      return this.$http({
        url: url,
        data: data
      }).finally(function () {
        _this4.loading = false;
      });
    },
    handleCreateOrUpdate: function handleCreateOrUpdate(scope, isSave) {
      var _this5 = this;
      if (isSave) {
        // 保存校验
        if (!scope.row.name || !scope.row.salary_type || !scope.row.type) {
          this.$message.warning(this.$t('required.msg'));
          return;
        }
        var id = scope.row.id;
        // url区分
        var url = id ? '/web/payroll_sub_project/updateItemImport' : '/web/payroll_sub_project/createitemimport';
        var data = {
          name: scope.row.name
        };

        // 参数区分
        if (id) {
          data.id = id;
        } else {
          data.cate_id = scope.row.salary_type;
          data.type = scope.row.type;
        }

        // 创建/更新
        this.create_or_update_salary_item(url, data).then(function () {
          var isCreate = !scope.row.id;
          if (isCreate) {
            _this5.adding = false;
          } else {
            // 同步最新的默认薪资名称
            scope.row.defaultName = data.name;
          }
          _this5.$set(scope.row, 'isSave', false);
          // 更新不需要刷新接口
          if (!id) {
            _this5.fetchTableData();
          }
        });
        return;
      }
      this.$set(scope.row, 'isSave', !isSave);
    },
    // 薪资/收入类型排序
    handleFilter: function handleFilter(_ref) {
      var prop = _ref.prop,
        order = _ref.order;
      if (order === 'default') {
        this.fetchTableData();
        return;
      }
      var sortvalue = prop === 'cate_id' ? [order === 'ascending' ? '10' : '8'] : order === 'ascending' ? '2' : '3';
      this.fetchTableData(_defineProperty({}, prop, sortvalue));
    },
    // 薪资/收入类型排序(废弃方法)
    handleSortChange: function handleSortChange(_ref2) {
      var column = _ref2.column,
        prop = _ref2.prop,
        order = _ref2.order;
      if (!order) {
        this.fetchTableData();
        return;
      }
      var sortvalue = prop === 'cate_id' ? [order === 'ascending' ? '10' : '8'] : order === 'ascending' ? '2' : '3';
      this.fetchTableData(_defineProperty({}, prop, sortvalue));
    },
    handleAppendTableColumn: function handleAppendTableColumn() {
      if (this.adding) {
        this.$message.warning(this.$t('war.msg'));
        return;
      }
      this.adding = true;
      this.tableData.push({
        // 薪资项名称
        name: '',
        // 薪资类型
        salary_type: '10',
        // 收入类型
        type: '2',
        // 0 启用 1 禁用
        status: 0,
        // 默认为保存状态
        isSave: true,
        switchValue: true
      });
    },
    // 取消保存
    handleCancelSave: function handleCancelSave(scope, index) {
      // 如果是新增的取消 直接删除
      if (!scope.row.id) {
        this.adding = false;
        this.tableData.splice(index, 1);
        return;
      }
      this.adding = false;
      scope.row.isSave = false;
      // 还原薪资名称
      scope.row.name = scope.row.defaultName;
    }
  }
};